export default __webpack_public_path__ + "static/media/settings_duotone.39dc3edd.svg";